import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@sm360/ui-library';
import { Vehicle, Quote } from '@sm360/widget-commons-vehicle';
import InstantEstimateWrapper from 'trade-in-360/components/InstantEstimateWrapper/InstantEstimateWrapper.jsx';
import ConfirmationModal from 'trade-in-360/components/ConfirmationModal/ConfirmationModal.jsx';
import 'trade-in-360/components/InstantEstimateModal/InstantEstimateModal.scss';

const InstantEstimateModal = ({
    onClose,
    openModal,
    tradeInVehicle,
    isShowroomV2Enabled,
    quote,
    isLoginModalOpen,
    isTrade360,
    onTradeInSuccess,
    appointmentEnabled,
    config,
}) => {
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);

    const handleCloseModal = ({ confirm, setClose }) => {
        if (confirm) setConfirmModalOpen(true);
        else {
            setClose();
            if (typeof onClose === 'function') onClose();
        }
    };

    const modalClassnames = `widget-sr makes__honda crm crm-modal ${isTrade360 ? 'trade-360-modal' : ''}`;

    return (
        <Modal
            isModalOpen={openModal}
            modalScopeCSS={isLoginModalOpen ? 'login-process' : ''}
            className={modalClassnames}
        >
            {({ setClose }) => (
                <>
                    <InstantEstimateWrapper
                        tradeInVehicle={tradeInVehicle}
                        isShowroomV2Enabled={isShowroomV2Enabled}
                        quote={quote}
                        closeModal={({ confirm }) => handleCloseModal({ confirm, setClose })}
                        isModal
                        onTradeInSuccess={onTradeInSuccess}
                        appointmentEnabled={appointmentEnabled}
                        config={config}
                    />
                    <ConfirmationModal
                        isOpen={confirmModalOpen}
                        onCancel={() => setConfirmModalOpen(false)}
                        onConfirm={() => {
                            setConfirmModalOpen(false);
                            setClose();
                            if (typeof onClose === 'function') onClose();
                        }}
                    />
                </>
            )}
        </Modal>
    );
};

InstantEstimateModal.defaultProps = {
    openModal: false,
    isTrade360: false,
    config: {},
};

InstantEstimateModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    openModal: PropTypes.bool,
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel).isRequired,
    isShowroomV2Enabled: PropTypes.bool.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired,
    isTrade360: PropTypes.bool,
    onTradeInSuccess: PropTypes.func.isRequired,
    appointmentEnabled: PropTypes.bool.isRequired,
    config: PropTypes.object,
};

InstantEstimateModal.displayName = 'InstantEstimateModal';
export default InstantEstimateModal;
